import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

const client = axios.create({
  baseURL: `${API_BASE_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
  // Use 'repeat' format for arrays: request_types=a&request_types=b (FastAPI compatible)
  paramsSerializer: {
    indexes: null, // This removes the [] from array params
  },
});

// Request interceptor for auth token
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('product_dashboard_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('product_dashboard_token');
      // Dispatch a custom event so AuthGuard can properly logout via Descope
      window.dispatchEvent(new CustomEvent('auth:force-logout'));
    } else if (error.response?.status === 403) {
      localStorage.setItem('product_dashboard_access_denied', 'true');
    }
    return Promise.reject(error);
  }
);

// Transform snake_case to camelCase
function snakeToCamel(str: string): string {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

export function transformKeys(obj: unknown): unknown {
  if (Array.isArray(obj)) {
    return obj.map(transformKeys);
  }
  if (obj !== null && typeof obj === 'object') {
    return Object.entries(obj as Record<string, unknown>).reduce(
      (acc, [key, value]) => {
        acc[snakeToCamel(key)] = transformKeys(value);
        return acc;
      },
      {} as Record<string, unknown>
    );
  }
  return obj;
}

export { client };
export default client;
